define('plugin/facebook-pixel/BookingInflator',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Booking inflator for Facebook Pixel plugin
     *
     * @class BookingInflator
     */
    return Marionette.Object.extend({
        inflate: function (contentData, model, data) {
            var bookingIds = data.booking_ids || [];

            _.extend(contentData, {
                content_ids: bookingIds,
            });

            contentData.contents.push({
                id: model.get('id'),
                name: model.get('name'),
                quantity: parseInt(model.get('qty')),
                price: parseFloat(model.get('price'))
            });
        }
    });

});

